import { Grid, Typography , Card} from '@mui/material'
import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import colors from '../../colors';
import { makeStyles } from '@mui/styles';

export const SinglePopularQuestion = (props) => {

  const useStyles = makeStyles({
    accordion:{
      width:'100%',
      background:colors.cyan
    },
    question:{
      color:colors.darkBlue,
      fontSize:'1.3rem',
      fontFamily:'GerberaMedium',
      textAlign:'left'
    },
    answer:{
      color:colors.black,
      fontSize:'1rem',
      fontFamily:'GerberaMedium',
      textAlign:'left'
    }
  })

  const classes = useStyles()
    
  return (

    <Grid container item md={12} xs={12} justifyContent={'center'}  >
          <Accordion className={classes.accordion} square={true} >
            <AccordionSummary expandIcon={<ExpandMoreIcon color='warning' />} >
              <Typography className={classes.question} >{props.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.answer}>{props.answer}</Typography>
            </AccordionDetails>
          </Accordion>
    </Grid>
    
  )
}
export default SinglePopularQuestion